/*
How this works:
 
1.      It looks at the part of your section ID that remains stable (featured_collection_TxhUMb)
2.      It finds the section on the page that contains this stable part, regardless of the template ID portion that changes
3.      It scrolls to that section automatically
*/


document.addEventListener('DOMContentLoaded', function() {
  // Klick-Handler, um Standardverhalten zu verhindern
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function(event) {
      const hash = this.getAttribute('href');
      if (hash && hash.includes('__')) {
        event.preventDefault();
        window.location.hash = hash; // Hash ändern, damit handleAnchorLinks getriggert wird
      }
    });
  });

  function handleAnchorLinks() {
    const hash = window.location.hash;

    if (hash && hash.includes('__')) {
      const stablePart = hash.split('__')[1]; // NUR den stabilen Teil extrahieren

      // Alle Sections suchen, egal welche dynamische ID
      const allSections = document.querySelectorAll('[id^="shopify-section-"], [id^="shopify-section-template--"]');

      for (let section of allSections) {
        if (section.id.includes(`__${stablePart}`)) {
          console.log("Gefundene Section:", section);
          setTimeout(() => {
            // Exaktes Scrollen mit Offset
            const sectionTop = section.getBoundingClientRect().top + window.scrollY - 200;
            window.scrollTo({
              top: sectionTop,
              behavior: 'smooth'
            });
          }, 100);
          break;
        }
      }
    }
  }
  // Run when the page loads
  handleAnchorLinks();

  // Also run when the hash changes
  window.addEventListener('hashchange', handleAnchorLinks);
});